import { ICellMetrics } from '_/types/extractionCells/extractionCellMetrics.types';
import zeusSdk from '_/utils/SDKs';

/**
 * Fetch current metrics for every cell routed to a project.
 * Calls the generic `callApi` escape hatch (not `getChildren`) because `cellmetrics` isn't in the
 * SDK's `availableChildren` allowlist yet - this route doesn't exist on the backend yet either.
 */
export const requestProjectCellMetrics = async (projectId: string): Promise<ICellMetrics[]> => {
  try {
    const metrics = await zeusSdk.projects.callApi({ method: 'GET', url: `${projectId}/cellmetrics` });
    return (metrics as ICellMetrics[]) || [];
  } catch (error) {
    console.error('Error fetching project cell metrics', error);
    return [];
  }
};
